import { useState } from 'react';
import Image from 'next/image';

import useTranslation from '@/utils/hooks/translation/useTranslation';

import { classNames } from '@/utils';

import PropTypes from 'prop-types';

//Components
import Icon from '@/components/base/Icon';

export const Img = ({ postId, mediaId, remoteMedia = false, src, imgFit }) => {
    const [errorImg, setErrorImage] = useState(false);
    const { t } = useTranslation();

    if (errorImg)
        return (
            <div className="flex h-full w-full flex-col items-center justify-center space-y-3 text-icoGray-500 dark:text-icoDarkMode-wolf">
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-icoGray-300 dark:bg-icoDarkMode-anthracite">
                    <Icon icon="content" />
                </span>
                <p className="text-sm">{t('commons:media_not_loaded')}</p>
            </div>
        );

    const alt = `${postId}-${mediaId}`;

    return remoteMedia ? (
        <div>
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
                src={src}
                alt={alt}
                className={classNames('h-full w-full', {
                    'object-contain': imgFit !== 'cover',
                    'object-cover': imgFit === 'cover'
                })}
                onError={() => setErrorImage(true)}
            />
        </div>
    ) : (
        <Image
            src={src}
            alt={alt}
            fill
            priority
            style={{ objectFit: imgFit }}
            sizes="(max-width: 768px) 100vw,
              50vw"
            onError={() => setErrorImage(true)}
        />
    );
};

Img.propTypes = {
    postId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    mediaId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    remoteMedia: PropTypes.bool,
    src: PropTypes.string,
    imgFit: PropTypes.oneOf(['contain', 'cover'])
};
